import { ErrorEmptyChannel } from 'components/error-handle/errors/error-empty-channel';
import { Header } from 'components/header';
import { ContentBox } from 'components/content-box';

export const EmptyChannelView = ({ isEmpty, isIframe, channelName }) => {
  if (isEmpty) {
    return (
      <>
        {isIframe && <Header />}
        <ContentBox>
          <ErrorEmptyChannel channelName={channelName} />
        </ContentBox>
      </>
    );
  } else {
    return null;
  }
};
